import { RCAlertType } from '@rc/ui';
import {
  updateClinicSuccess,
  updateVet,
  updateVetFail,
  updateVetSuccess,
  updateVetUser,
  updateVetUserFail,
  updateVetUserSuccess,
} from './../vet.actions';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { catchError, concatMap, map, switchMap, tap } from 'rxjs/operators';
import { setAlert, toggleLoader } from '@app/store/core';
import { of } from 'rxjs';
import { VetService } from '@app/core/services/network/vet/vet.service';
import { LocalizationService } from '@app/core/services/utils/localization/localization.service';
import { Clinic, Vet } from '@app/core/models';
import { updateClinic } from '../vet.actions';
import { Router } from '@angular/router';

@Injectable()
export class VetEffects {
  /**
   * Update vet using API call
   */
  updateVet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateVet),
      concatMap((action) =>
        this.vetService.apiUpdateVet(action.vet).pipe(
          map((vet: Vet) => updateVetSuccess({ vet })),
          tap(() => {
            if (action.reload) {
              window.location.reload();
            }
          }),
          catchError((err) => of(updateVetFail({ errorMessage: err }))),
        ),
      ),
    ),
  );

  /**
   * Update vet user using API call
   */
  updateVetUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateVetUser),
      concatMap((action) =>
        this.vetService.updateOktaVet(action.oktaId, action.vetUser).pipe(
          tap(() => {
            if (this.localeId !== action.vetUser.preferredLanguage) {
              LocalizationService.setLanguageAndReload(action.vetUser.preferredLanguage);
            }
          }),
          map(() => updateVetUserSuccess({ vetUser: action.vetUser })),
          catchError((err) => of(updateVetUserFail({ errorMessage: err }))),
        ),
      ),
    ),
  );

  /**
   * Update clinic using API call
   */
  updateClinic$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateClinic),
      switchMap((action) =>
        this.vetService.apiUpdateClinic(action.clinicId, action.clinic).pipe(
          switchMap((clinic: Clinic) => [updateClinicSuccess({ clinic }), toggleLoader({ value: false })]),
          tap(() => action.redirectTo && this.router.navigate([...action.redirectTo])),
          catchError(() => [
            setAlert({
              alert: {
                message: $localize`:@@error_general_text:`,
                alertType: RCAlertType.ERROR,
                dataQa: 'vs-update-clinic-error-alert',
              },
            }),
            toggleLoader({ value: false }),
          ]),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private vetService: VetService,
    @Inject(LOCALE_ID) protected localeId: string,
    private router: Router,
  ) {}
}
